<template>
  <div>
    <page-heading :title="$t(`${translationPrefix}.title`)"></page-heading>
    <el-card>
      <el-form
        ref="passwordForm"
        :model="passwordFormData"
        :rules="passwordFormRules"
        :label-width="$root.labelWidth"
        label-position="right"
        v-loading="processing"
        v-if="query.reset_password"
      >
       
        <el-form-item :label="$t('modules.user.fields.password.label')" prop="password">
          <el-input
            type="password"
            v-model.lazy.trim="passwordFormData.password"
            :placeholder="$t('modules.user.fields.password.placeholder')"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('modules.user.fields.passwordConfirmation.label')"
          prop="password_confirmation"
        >
          <el-input
            type="password"
            v-model.lazy.trim="passwordFormData.password_confirmation"
            :placeholder="$t('modules.user.fields.passwordConfirmation.placeholder')"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitPasswordForm('passwordForm')">{{
            $t("buttons.submit")
          }} </el-button>
        </el-form-item>
      </el-form>

      <el-form
        ref="emailForm"
        :model="emailFormData"
        :rules="emailFormRules"
        :label-width="$root.labelWidth"
        label-position="right"
        v-loading="processing"
        v-else-if="!isTokenExpired"
      >
      
        <el-form-item :label="$t('modules.user.fields.email.label')" prop="email">
          <el-input
            type="email"
            v-model.lazy.trim="emailFormData.email"
            :placeholder="$t('modules.user.fields.email.placeholder')"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitEmailForm('emailForm')">{{
            $t("buttons.submit")
          }}</el-button>
        </el-form-item>

        <router-link :to="{ name: 'home' }"
          ><a>{{ $t(`${translationPrefix}.buttons.backToLogin`) }}</a></router-link
        >
      </el-form>

      <div v-else>
       <p> token={{token}}</p>
        <p> <strong>{{$t("pages.passwordReset.tokenExpired")}} </strong> </p>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import validations from '@/utils/validations';
import { showSuccessMessage, showErrorMessage } from '@/ui/message';

export default {
  name: 'PasswordResetPage',
  data() {
    return {
      translationPrefix: 'pages.passwordReset',
      query: this.$router.currentRoute.query,
      redirectUrl: `${window.location.protocol}//${window.location.host}${this.$router.currentRoute.path}`,
      emailFormRules: {
        email: [{ ...validations.required }, { ...validations.email }],
      },
      emailFormData: {
        email: '',
      },
      passwordFormRules: {
        password: [{ ...validations.required }],
        password_confirmation: [{ ...validations.required }],
      },
      passwordFormData: {
        password: '',
        password_confirmation: '',
      },
    };
  },
  computed: {
    ...mapGetters('entities/users/', ['currentUser', 'processing']),
    isTokenExpired() {
      return this.$route.query.token_expired;
    },
    token() {
      return this.$route.query.token;
    },
  },
  methods: {
    submitEmailForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store
            .dispatch('entities/users/sendPasswordReset', {
              ...this.emailFormData,
              redirect_url: this.redirectUrl,
            })
            .then((response) => {
              if (response.status) {
                showSuccessMessage(this.$t('modules.user.messages.passwordResetSent'));
              } else {
                showErrorMessage(response.error);
              }
            });
        } else {
          showErrorMessage(this.$t('form.messages.notValid'));

          return false;
        }

        return true;
      });
    },
    submitPasswordForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store
            .dispatch('entities/users/updatePassword', {
              ...this.passwordFormData,
              uid: this.query.uid,
              client: this.query.client_id,
              'access-token': this.query.token,
            })
            .then((response) => {
              if (response.status) {
                showSuccessMessage(this.$t('modules.user.messages.passwordUpdated'));

                this.$router.replace({ name: 'home' });
              } else {
                showErrorMessage(response.error);
              }
            });
        } else {
          showErrorMessage(this.$t('form.messages.notValid'));

          return false;
        }
        return true;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/PasswordReset.vue